import { render } from "./AddNewTransactionModal.vue?vue&type=template&id=571e8b5c&ts=true"
import script from "./AddNewTransactionModal.vue?vue&type=script&lang=ts"
export * from "./AddNewTransactionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__